import { z } from 'zod';

export const answerSchema = z.object({
  question_id: z.number(),
  is_correct: z.boolean(),
  selected_answer: z.string(),
  is_submitted: z.boolean(),
  time_spent: z.number(),
});

export type AnswerSchema = z.infer<typeof answerSchema>;
